<template>
    <BDropdown
               size="xl" :noCaret="true"
               :noFade="true"
               :noFlip="true"
               auto-close="outside"
               class="js-waves-off"
    >
        
        <template #button-content>
            <div class="header-icon"  :title="notification_title">
                <i class="fal fa-bell"></i>
                <span v-if= "messages.length>0" class="badge badge-icon">{{ messages.length }}</span>
            </div>
        </template>
        
        <BDropdownForm formClass="no-padding min_width_350">
            
            <div class=" dropdown-xl">
                <div class="dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center rounded-top mb-2">
                    <h4 class="m-0 text-center color-white">
                        Повідомлення
                    </h4>
                </div>
                
                <div class="tab-content tab-notification">
                    <div class="tab-pane p-3 text-center" v-if="!has_messages" :class="{'active' : !has_messages}">
                        <h5 class="mt-4 pt-4 fw-500">
                            <small class="mt-3 fs-b fw-400 text-muted">
                                Тут Ви маєте можливість переглянути повідомлення
                            </small>
                        </h5>
                    </div>
                    
                    <div class="tab-pane" id="tab-messages" role="tabpanel"  :class="{'active' : has_messages}">
                        <div class="custom-scroll h-100">
                            <ul class="notification">
                                
                                <li class="unread" v-for="msg in this.messages">
                                   <span class="d-flex flex-column flex-1 ml-1">
                                        <span class="name"> {{msg.title}} <span class="badge badge-primary fw-n position-absolute pos-top pos-right mt-1">INFO</span></span>
                                        <span class="msg-a fs-sm">{{msg.text}}</span>

                                        <span class="fs-nano text-muted mt-1"></span>
                                   </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="py-2 px-3 bg-faded d-block rounded-bottom text-right border-faded border-bottom-0 border-right-0 border-left-0">
                    <a href="/profile" class="fs-xs fw-500 ml-auto">Перейти до кабінету</a>
                </div>
            </div>
        </BDropdownForm>
    </BDropdown>
</template>

<script>

import {BDropdown} from "bootstrap-vue-next";
import {BDropdownForm} from "bootstrap-vue-next";
import {mapGetters} from "vuex";

export default {
    name: "userNotification",
    components: {
        BDropdown,
        BDropdownForm
    },
    computed: {
        ...mapGetters({
            'user': "user/getUser",
            'settings' : "user/getUserTenderSettings",
        }),
        
        messages() {
            
            let res = [];
            
            if(this.is_on_verify) {
                 res.push({
                     text:'Профіль перевіряється співробітником ІМК. ',
                     title: 'Профіль не перевірений!',
                     type: 'warning',
                });
            }
            
            if(this.is_subscribe_email_off) {
                res.push({
                    text: 'Перевірте налаштування в "Мій кабінет"',
                    title: 'E-mail розсилка відключена!',
                    type: 'warning',
                });
            }
            
            if(this.is_blocked) {
                res.push({
                    text:'Можливість участі в тендері відключена співробітником ІМК',
                    title: 'Профіль заблокований!!!',
                    type: 'warning',
                });
            }
            
            
            return res;
        },
        
        has_messages() {
            return this.messages.length > 0;
        },
        
        notification_title() {
            
            if(this.is_on_verify) {
                return 'Профіль не перевірений!';
            }
            
            if(this.is_subscribe_email_off) {
                return 'E-mail розсилка відключена!';
            }
            
            if(this.is_blocked) {
                return 'Профіль заблокований!';
            }
            
            return "Повідомлень немає";
        },
        
        is_on_verify() {
            return !this.settings.verifed;
        },
        
        is_blocked () {
            return this.user.blacklist;
        },
        
        is_subscribe_email_off() {
            return this.settings.subscription_deactivated
        }
        
    },
}
</script>


<style scoped>

</style>